// src/components/DocumentForm.tsx
import React, { useState, FormEvent } from 'react';
import { DocumentData } from '../types/Document.ts';

interface DocumentFormProps {
  onGenerate: (newDoc: DocumentData) => void;
}

const DocumentForm: React.FC<DocumentFormProps> = ({ onGenerate }) => {
  const [prompt, setPrompt] = useState<string>("");

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const generatedDoc: DocumentData = {
      id: 999,
      title: "生成文書(モック)",
      content: `ユーザプロンプト: "${prompt}" に基づいて生成されたドキュメント(テスト用固定メッセージ)。`
    };
    onGenerate(generatedDoc);
    setPrompt("");
  }

  return (
    <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
      <label htmlFor="prompt">ドキュメント生成用プロンプト:</label>
      <textarea
        id="prompt"
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder="ここに文章のキーワードや生成したい文書種別を入力..."
        style={{ width: '100%', height: '100px', margin: '10px 0' }}
      />
      <button type="submit">生成</button>
    </form>
  );
};

export default DocumentForm;
